exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".FaqEntry {\n  margin: 32px 0; }\n  .FaqEntry-question {\n    cursor: pointer; }\n    .FaqEntry-question:hover {\n      color: #0068e9; }\n", ""]);

// exports
